import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.string.trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'allTreeSelect',
  model: {
    prop: 'selectKey',
    event: 'change'
  },
  props: {
    lazy: {
      type: Boolean,
      default: false
    },
    load: Function,
    nodeKey: {
      type: String,
      default: 'id'
    },
    treeData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultProps: {
      type: Object,
      default: function _default() {
        return {
          children: 'children',
          label: 'label',
          id: 'id',
          icon: 'icon'
        };
      }
    },
    selectKey: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: ''
    },
    // 渲染树节点的render函数
    renderTreeContent: Function
  },
  computed: {
    treeStyle: function treeStyle() {
      if (this.lazy) {
        return 'max-height: 273px, height: 273px';
      }

      return 'max-height: 220px; height: 220px';
    },
    // 默认展开node
    defaultExpandedKey: function defaultExpandedKey() {
      if (this.lazy) {
        return [];
      }

      return [this.selectKey];
    }
  },
  watch: {
    iconIsReverse: function iconIsReverse(val) {
      if (!val) {
        this.$refs.treeDropdown.hide();
      }
    },
    selectLabel: function selectLabel(val) {
      this.inputContent = val;
    }
  },
  data: function data() {
    return {
      defaultKey: '',
      inputContent: '',
      checkedNodes: [],
      dropdownState: false,
      iconIsReverse: false,
      filterText: '',
      dropdownMenuWidth: '',
      // 下拉展开区域最小宽度
      minDropdownMenuWidth: 220
    };
  },
  mounted: function mounted() {
    var _this = this;

    // 初始化下方宽度
    this.$nextTick().then(function () {
      _this.getDropdownMenuWidth();
    });
  },
  methods: {
    searchIconClick: function searchIconClick() {
      // 搜索树内容
      if (!String.prototype.trim.call(this.filterText)) {
        this.$emit('clearSearch');
      } else {
        this.$emit('search', this.filterText);
      }
    },
    // 更新下拉框宽度
    getDropdownMenuWidth: function getDropdownMenuWidth() {
      if (this.$refs.treeDropdown && this.$refs.treeDropdown.$el.clientWidth) {
        var width = this.$refs.treeDropdown.$el.clientWidth >= this.minDropdownMenuWidth ? this.$refs.treeDropdown.$el.clientWidth : this.minDropdownMenuWidth;
        this.dropdownMenuWidth = {
          width: "".concat(width, "px")
        };
      }
    },
    dropdownClick: function dropdownClick(val) {
      this.iconIsReverse = val;
      this.getDropdownMenuWidth();
    },
    renderContent: function renderContent(h, _ref) {
      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;

      // 定义默认值的显示
      if (data[this.nodeKey] === this.selectKey) {
        this.getDefault(data);
      }

      if (this.renderTreeContent) {
        return this.renderTreeContent(h, {
          node: node,
          data: data,
          store: store
        });
      }

      return h("span", {
        "class": "el-tree-node__label"
      }, [data[this.defaultProps.label]]);
    },
    // 获取高亮
    getDefault: function getDefault(data) {
      this.inputContent = data[this.defaultProps.label];
    },
    treeNodeClick: function treeNodeClick(data) {
      this.iconIsReverse = false; // 选中回调

      this.$emit('change', data[this.nodeKey]);
      this.dispatch('ElFormItem', 'el.form.change', [data[this.nodeKey]]);
      this.dispatch('ElFormItem', 'el.form.blur', [data[this.nodeKey]]);
      this.$emit('selectNode', data);
    },
    openDropdown: function openDropdown() {
      this.iconIsReverse = !this.iconIsReverse;
      this.getDropdownMenuWidth();
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data[this.defaultProps.label].indexOf(value) !== -1;
    },
    reset: function reset() {
      if (this.lazy) {
        this.$refs.elTree.reload();
      }

      this.inputContent = '';

      if (!this.isLazy) {
        this.filterText = '';
      }
    },
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }

      if (parent) {
        // eslint-disable-next-line prefer-spread
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    }
  }
};